import { CSSProperties, PropsWithChildren, useContext, useEffect, useRef, useState } from 'react';
import { RtcInputContext } from '../context/rtc-input-context';
import { RtcInput } from '../util/input/rtc';
import { AudioRecorderContext } from '../context/audio-recorder-context';
import { RtcConnection } from '../util/rtc/connection';
import { RtcSignalingContext } from '../context/rtc-signaling-context';
import { useExternalState } from '../hooks/use-external-state';
import { Duration } from '@nimey/units';
import { MdVolumeOff, MdVolumeUp } from 'react-icons/md';

export type RtcInputProviderProps = {
  name: string;
  rtcConnection: RtcConnection;
}

export const Name = () => {
  const ctx = useContext(RtcInputContext);
  const rtcContext = useContext(RtcSignalingContext);

  const nameMap = useExternalState(rtcContext.signaling!.nameMap)
  if(ctx.input && nameMap[ctx.input.getName()]) return <>{ nameMap[ctx.input.getName()] }</>
  return <>{ctx.input?.getName()}</>
}


export const Visualizer = (props: {width: number, height: number, style?: CSSProperties}) => {
  const ctx = useContext(RtcInputContext);
  const canvasRef = useRef<HTMLCanvasElement>(null)
  useEffect(() => {
    setTimeout(() => {
      if(ctx?.input && canvasRef.current) {
        ctx.input.connectCanvas(canvasRef.current)
      }
    }, 1000);
  }, [])

  return <canvas ref={canvasRef} {...props} />
}

export const ToogleMute = () => {
  const ctx = useContext(RtcInputContext);
  const isMuted = useExternalState(ctx.input!.isMuted);

  return (
    <div onClick={(e) => ctx.input?.toggleMute()} className={isMuted ? 'muted' : ''}>
        {/* {isMuted ? <MdVolumeOff /> : <MdVolumeUp />} */}
    </div>
  )
}

class RtcProvider {
  protected instances: Record<string, RtcInput> = {};
  getRtc(userId: string, name: string, ctx: AudioContext, rtc: RtcConnection) {
    const key = [userId, name].join('--');
    if(!this.instances[key]) this.instances[key] = new RtcInput(name, ctx, rtc);

    return this.instances[key];
  }
}

const rtcProvider = new RtcProvider();

export const Provider = (props: PropsWithChildren<RtcInputProviderProps>) => {
  const ctx = useContext(AudioRecorderContext);
  const input = rtcProvider.getRtc(props.rtcConnection.peerUserId, props.name, ctx.recorder!.getContext(), props.rtcConnection);
  useEffect(() => {
    ctx.recorder!.addInput(input)
    return () => {
      ctx.recorder!.removeInput(input)
    }
  }, [])
  return (
    <RtcInputContext.Provider value={{input: input}}>
      {props.children}
    </RtcInputContext.Provider>
  );
}